var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 0H7.58333C5.97508 0 4.66667 1.30842 4.66667 2.91667V6.41667C4.66667 8.02492 5.97508 9.33333 7.58333 9.33333H11.0833C12.6916 9.33333 14 8.02492 14 6.41667V2.91667C14 1.30842 12.6916 0 11.0833 0ZM12.8333 6.41667C12.8333 7.3815 12.0482 8.16667 11.0833 8.16667H7.58333C6.6185 8.16667 5.83333 7.3815 5.83333 6.41667V2.91667C5.83333 1.95183 6.6185 1.16667 7.58333 1.16667H11.0833C12.0482 1.16667 12.8333 1.95183 12.8333 2.91667V6.41667ZM9.33333 11.0833C9.33333 12.6916 8.02492 14 6.41667 14H2.91667C1.30842 14 0 12.6916 0 11.0833V7.58333C0 5.97508 1.30842 4.66667 2.91667 4.66667C3.23925 4.66667 3.5 4.928 3.5 5.25C3.5 5.572 3.23925 5.83333 2.91667 5.83333C1.95183 5.83333 1.16667 6.6185 1.16667 7.58333V11.0833C1.16667 12.0482 1.95183 12.8333 2.91667 12.8333H6.41667C7.3815 12.8333 8.16667 12.0482 8.16667 11.0833C8.16667 10.7613 8.42742 10.5 8.75 10.5C9.07258 10.5 9.33333 10.7613 9.33333 11.0833Z",
    fill: "#6A7181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.540a42a2c68d2428a5636417676b00f4.svg";
export { ForwardRef as ReactComponent };